import * as React from "react";
import { useMemo } from "react";
import Button from "@/components/atomics/button";
import { telegramBotLink } from "@/config";

interface UnlockSuccessModalProps {
  className?: string;
  onClose: () => void;
  rewardLabel: string;
}

export default function UnlockSuccessModal({
  className,
  onClose,
  rewardLabel,
}: UnlockSuccessModalProps) {
  const isMiniApp = useMemo(() => {
    const tg = window.Telegram?.WebApp;
    return (
      typeof window !== "undefined" &&
      tg &&
      !!tg.initData &&
      tg.platform !== "unknown"
    );
  }, []);

  return (
    <div className={className}>
      <div className="relative">
        <header className="relative flex justify-start items-center pl-[20px] pr-[20px] pt-[12px] pb-[12px] bg-primary-blue">
          <div className="text-[28px]">
            <span>INFORMATION</span>
          </div>
          <div
            className="absolute right-[20px] w-[21px] h-[29px] hover:cursor-pointer"
            onClick={onClose}
          >
            <img src="/assets/cancel.svg" alt="cancel" />
          </div>
        </header>
        <main className="flex flex-col justify-start items-center pt-[58px] pb-[30px] pl-[49px] pr-[49px] text-[24px]">
          <div className="flex flex-col items-center mb-8">
            <p className="flex flex-col items-center">
              {isMiniApp ? (
                <span className="text-[24px] uppercase mb-2">
                  "{rewardLabel}" has been successfully unlocked!
                </span>
              ) : (
                <span className="text-[20px] mt-2">
                  Instructions sent in{" "}
                  <a
                    href={telegramBotLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-blue underline hover:opacity-80"
                  >
                    Bot
                  </a>
                </span>
              )}
            </p>
          </div>

          <div className="w-full">
            <Button
              className="w-full custom-aspect-320-63 text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
              image="/assets/button.svg"
              text="OK"
              onClick={onClose}
            />
          </div>
        </main>
      </div>
    </div>
  );
}
